export class ItemMenu {
    link: string = null;
    nome: string = null;
    icone: string = null;
  
    constructor(values: Object = {}) {
      Object.assign(this, values);
    }
  }
  


// WEBPACK FOOTER //
// ./src/app/_models/menu/item-menu.ts